import { useState } from "react";
import { supabase } from "../lib/supabase";
import { emitToast } from "../components/Toast";

export function Login() {
  const [busy, setBusy] = useState(false);
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");

  async function signInPassword(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password: pwd });
    if (error) { emitToast("error", error.message); setBusy(false); }
    // sucesso: onAuthStateChange no App troca pra área administrativa
  }

  async function signInGoogle() {
    setBusy(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo: `${window.location.origin}/admin`, queryParams: { hd: "reachup.pro", prompt: "select_account" } },
    });
    if (error) { emitToast("error", error.message); setBusy(false); }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100dvh", gap: "var(--s-5)", padding: "var(--s-5)" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 13, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--rouge)" }}>Reach Up</div>
        <h1 style={{ marginTop: "var(--s-2)" }}>Avaliação Técnica</h1>
        <p className="muted" style={{ marginTop: "var(--s-2)", fontSize: 14 }}>Painel do revisor · acesso restrito @reachup.pro</p>
      </div>

      <form onSubmit={signInPassword} style={{ display: "flex", flexDirection: "column", gap: "var(--s-3)", width: "100%", maxWidth: 340 }}>
        <div className="field"><span>E-mail</span><input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@reachup.pro" required /></div>
        <div className="field"><span>Senha</span><input type="password" autoComplete="current-password" value={pwd} onChange={(e) => setPwd(e.target.value)} required /></div>
        <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={busy}>{busy ? "Entrando…" : "Entrar"}</button>
      </form>

      <div style={{ display: "flex", alignItems: "center", gap: "var(--s-3)", width: "100%", maxWidth: 340, color: "var(--cream-3)", fontSize: 12 }}>
        <span style={{ flex: 1, height: 1, background: "var(--ink-3)" }} /> ou <span style={{ flex: 1, height: 1, background: "var(--ink-3)" }} />
      </div>

      <button className="btn btn-ghost btn-block" style={{ maxWidth: 340 }} onClick={signInGoogle} disabled={busy}>Entrar com Google</button>
    </div>
  );
}
